import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/clubs/$slug/stats")({
  component: StatsPage,
});

function StatsPage() {
  return <div />;
}
